export enum AttachmentId {
  PassportImage = 1,
  SignatureImage = 2,
}
